import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import {withAttrs} from "../common/utils.js";
import EditableComponent from "./editable-component.js";
import {colors, fontFamily, gap, lineHeight, media, shadow} from "./theme.js";
import {Title} from "./typo.js";
import Img from "./image.js";
import Stack from "./stack.js";
import PageContact from "./page-contact.js";
import Doc from "./doc.js";
import {t} from "../common/i18n.js";
import Icon from "./icon.js";
export default function PrintTemplatesPage(props) {
  const {page, categoryPrintTemplates} = props;
  const {headline, image, contact, sections, ...rest} = page.content;
  return /* @__PURE__ */ React.createElement(EditableComponent, {
    ...rest
  }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(Headline, null, headline), /* @__PURE__ */ React.createElement(Image, {
    ...image,
    sizes: [400]
  })), /* @__PURE__ */ React.createElement(Main, null, sections.map((s) => /* @__PURE__ */ React.createElement(Section, {
    key: s._uid,
    ...s,
    categoryPrintTemplates
  })), /* @__PURE__ */ React.createElement(PageContact, {
    ...contact[0]
  }))));
}
function Section(props) {
  const {
    icon,
    headline,
    description,
    downloads_category,
    categoryPrintTemplates
  } = props;
  const printTemplates = downloads_category ? categoryPrintTemplates[downloads_category.id] : [];
  return /* @__PURE__ */ React.createElement(EditableComponent, {
    ...props
  }, /* @__PURE__ */ React.createElement(SectionContainer, null, /* @__PURE__ */ React.createElement(SectionHeadline, null, icon && icon.filename && /* @__PURE__ */ React.createElement(HeadlineIcon, {
    ...icon
  }), headline), description && /* @__PURE__ */ React.createElement(SectionDescription, {
    ...description
  }), printTemplates && /* @__PURE__ */ React.createElement(Downloads, null, /* @__PURE__ */ React.createElement(DownloadsHeadline, null, t("Druckvorlagen Standardgrößen")), printTemplates.map((p) => /* @__PURE__ */ React.createElement(Download, {
    key: p.index,
    ...p
  })))));
}
function Download(props) {
  const {headline, url, filename} = props;
  return /* @__PURE__ */ React.createElement(DownloadContainer, null, /* @__PURE__ */ React.createElement(DownloadHeadline, null, headline), /* @__PURE__ */ React.createElement(DownloadLink, {
    href: url,
    download: true
  }, /* @__PURE__ */ React.createElement(I, {
    name: "download"
  }), filename));
}
const Container = styled.div`
  max-width: 870px;
  margin: auto;
  padding: 80px 0 100px;

  ${media.phone} {
    padding: 32px 0 100px;
  }
`;
const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 100px;

  ${media.phone} {
    grid-template-columns: 1fr;
    grid-gap: 50px;
    margin-bottom: 60px;
  }
`;
const Headline = styled(withAttrs(Title, {level: 1}))`
  font-size: 46px;

  ${media.phone} {
    font-size: 30px;
  }
`;
const Image = styled(Img)`
  max-width: 100%;
`;
const Main = styled(withAttrs(Stack, {spacing: "xxl"}))`
  ${media.phone} {
    --spacing: 57px;
  }
`;
const SectionContainer = styled.div`
  padding: 56px;
  box-shadow: ${shadow.card};
  border-radius: 4px;
  overflow: hidden;

  ${media.phone} {
    padding: 0;
    box-shadow: none;
  }
`;
const SectionHeadline = styled(withAttrs(Title, {level: 2}))`
  display: flex;
  align-items: center;
  ${gap("16px")}
  font-size: 30px;
  margin-bottom: 50px;

  ${media.phone} {
    font-size: 20px;
    margin-bottom: 24px;
  }
`;
const SectionDescription = styled(Doc)`
  ul {
    list-style: none;
  }

  li {
    position: relative;
  }

  li:before {
    content: "✓";
    color: ${colors.g};
    position: absolute;
    left: -0.7em;
    top: 0;
    font-size: 1.5em;
  }
`;
const HeadlineIcon = styled(Img)`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;
const Downloads = styled(withAttrs(Stack, {spacing: "l"}))`
  margin-top: 60px;

  ${media.phone} {
    margin-top: 30px;
    --spacing: 16px;
  }
`;
const DownloadsHeadline = styled.div`
  font-family: ${fontFamily.secondary};
  font-weight: bold;
  font-size: 24px;
  line-height: ${lineHeight}
  margin-bottom: 40px;

  ${media.phone} {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;
const DownloadContainer = styled.div``;
const DownloadHeadline = styled.div`
  font-family: ${fontFamily.secondary};
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;

  ${media.phone} {
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 8px;
  }
`;
const DownloadLink = styled.a`
  display: flex;
  gap: 4px;
  font-family: ${fontFamily.primary};
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.c};
  text-decoration: none;

  ${media.phone} {
    font-size: 14px;
    line-height: 22px;
  }
`;
const I = styled(Icon)``;
